(() => {
  if (window.__abmProductTrustReady) return;
  window.__abmProductTrustReady = true;

  const clickTrigger = element => {
    if (!element) return false;
    try {
      element.dispatchEvent(new MouseEvent('pointerdown', { bubbles: true, cancelable: true, view: window }));
      element.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
      element.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
      element.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      return true;
    } catch (error) {
      try { element.click(); return true; } catch (fallbackError) { return false; }
    }
  };

  const openSignalAI = () => {
    if (window.SignalAI?.open) { window.SignalAI.open(); return true; }
    if (window.SignalAI?.toggle) { window.SignalAI.toggle(); return true; }
    if (window.__signal_ai?.open) { window.__signal_ai.open(); return true; }

    const root = document.getElementById('chizy-chat-root');
    if (root) {
      root.style.display = '';
      root.style.visibility = 'visible';
      root.style.opacity = '1';
      root.style.pointerEvents = 'auto';
    }

    const selectors = [
      '#chizy-v2-split-shell',
      '#chizy-chat-root [role="button"]',
      '#chizy-chat-root .chizy-bubble-wrapper-v2',
      '#chizy-chat-root .chizy-bubble-container-v2',
      '#chizy-chat-root .chizy-bubble-custom-icon-v2',
      '.chizy-bubble-wrapper-v2',
      '.chizy-bubble-container-v2',
      '.chizy-bubble-custom-icon-v2'
    ];

    for (const selector of selectors) {
      const trigger = document.querySelector(selector);
      if (trigger && clickTrigger(trigger)) return true;
    }

    if (window.Chizy?.open) { window.Chizy.open(); return true; }
    if (window.chizyChat?.open) { window.chizyChat.open(); return true; }
    if (window.ChizyAgent?.open) { window.ChizyAgent.open(); return true; }
    return false;
  };

  window.abmOpenScienceChat = event => {
    event?.preventDefault();
    event?.stopPropagation();
    if (openSignalAI()) return false;

    let attempts = 0;
    const retry = window.setInterval(() => {
      attempts += 1;
      if (openSignalAI() || attempts >= 20) window.clearInterval(retry);
    }, 200);
    return false;
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-abm-open-science-chat]');
    if (trigger) window.abmOpenScienceChat(event);
  });
})();